import { createReducer } from "@reduxjs/toolkit";
import { resetUpdateStudentProfile, updateStudentProfile } from "./update-student-profile";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const updateStudentProfileReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(updateStudentProfile.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(updateStudentProfile.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updateStudentProfile.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdateStudentProfile, () => {
    return initialState;
  });
});
